<form name="userForm" [formGroup]="userForm" novalidate>
  <div class="card">
    <div class="card-body">
      <span class="profile-rounded-label">IDENTIFICACIÓN</span>
      <div class="row mt-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="user" class="form-label">
            Usuario
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="user" formControlName="user">
          <span class="text-danger"
            *ngIf="userForm.get('user').hasError('required')">
            <strong>Usuario es Requerido</strong>
          </span>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="fullName" class="form-label">
            Nombre Completo
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="fullName" formControlName="fullName">
          <span class="text-danger"
                *ngIf="userForm.get('fullName').hasError('required')">
            <strong>Nombre Completo es Requerido</strong>
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="leadership" class="form-label">
            Dirección administrativa
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="leadership" formControlName="leadership">
          <span class="text-danger"
                *ngIf="userForm.get('leadership').hasError('required')">
            <strong>Dirección es Requerido</strong>
          </span>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="role" class="form-label">
            Rol de Usuario
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <select class="form-control" id="role" formControlName="role">
            <option *ngFor="let role of roles" value="{{ role.id_rol }}">{{ role.nombre }}</option>
          </select>
          <span class="text-danger"
                *ngIf="userForm.get('role').hasError('required')">
            <strong>Rol de Usuario es Requerido</strong>
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="oldCode" class="form-label">
            Código de Antigüedad
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="oldCode" formControlName="oldCode">
          <span class="text-danger"
                *ngIf="userForm.get('oldCode').hasError('required')">
            <strong>Código de Antigüedad es Requerido</strong>
          </span>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="administrativeUnit" class="form-label">
            Unidad Administrativa
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="administrativeUnit" formControlName="administrativeUnit">
          <span class="text-danger"
                *ngIf="userForm.get('administrativeUnit').hasError('required')">
            <strong>Unidad Administrativa es Requerido</strong>
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="job" class="form-label">
            Puesto
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="job" formControlName="job">
          <span class="text-danger"
                *ngIf="userForm.get('job').hasError('required')">
            <strong>Puesto es Requerido</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3">
    <div class="card-body">
      <span class="profile-rounded-label">INFORMACIÓN DE CONTACTO</span>
      <div class="row mt-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <label for="email" class="form-label">
            Correo Electrónico
            <span class="text-danger"><strong>*</strong></span>
          </label>
          <input type="text" class="form-control" id="email" formControlName="email">
          <span class="text-danger"
                *ngIf="userForm.get('email').hasError('required')">
            <strong>Correo Electrónico es Requerido</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5">
    <div class="row">
      <div class="col-12">
        <button type="button"
          [routerLink]="['/modulo-seguridad/', 'seguridad', 'listado-usuarios']"
          (click)="selectedTab('listado-usuarios')"
          class="btn round-button">
          Cancelar
        </button>
        <button
          *ngIf="!isEdit"
          [disabled]="!userForm.valid"
          type="button"
          (click)="createUserProfile()"
          class="ml-3 btn round-button">
            Guardar
        </button>
        <button
          *ngIf="isEdit"
          [disabled]="!userForm.valid"
          type="button"
          (click)="updateProfile()"
          class="ml-3 btn round-button">
          Actualizar
        </button>
      </div>
    </div>
  </div>
</form>

